export default __webpack_public_path__ + "media/images/portfolio/gallery-09-370x220-079ef728ce5e761fea96353cbe59a834.jpg";